import { z } from "zod"
import { salesStatusSchema, stockStatusFilterSchema, vehicleTypeFilterSchema } from "../common"

const listingVisibilityValues = ["VISIBLE", "INVISIBLE", "INVALID"] as const
const listingQualityValues = ["GOOD_QUALITY", "MEDIUM_QUALITY", "LOW_QUALITY"] as const

const preprocessBoolean = (value: unknown) => {
	if (Array.isArray(value)) {
		return value[0] === "true" ? true : value[0] === "false" ? false : value[0]
	}

	return value === "true" ? true : value === "false" ? false : value
}

const nullToUndefined = (value: unknown) => (value === null ? undefined : value)

export const listingVisibilitySchema = z.enum(listingVisibilityValues)
export const listingQualitySchema = z.enum(listingQualityValues)
export const enginePowerUnitSchema = z.enum(["kW", "PS"])

export const inventoryListFilterValueSchema = z.object({
	accidentFree: z.preprocess(preprocessBoolean, z.boolean()).optional(),
	bodyTypes: z.array(z.string()).optional(),
	dealershipIds: z.array(z.string()).optional(),
	derivatives: z.array(z.string()).optional(),
	driveTrains: z.array(z.string()).optional(),
	enginePowerUnit: enginePowerUnitSchema.optional(),
	engineTypes: z.array(z.string()).optional(),
	equipmentTags: z.array(z.string()).optional(),
	exteriorColors: z.array(z.string()).optional(),
	interiorColors: z.array(z.string()).optional(),
	listingQuality: z.array(listingQualitySchema).optional(),
	listingVisibility: z.array(listingVisibilitySchema).optional(),
	maxFirstRegistrationDate: z.string().optional(),
	maxMileage: z.string().optional(),
	maxModelYear: z.string().optional(),
	maxPrice: z.string().optional(),
	minEnginePower: z.preprocess(nullToUndefined, z.string().optional()),
	minFirstRegistrationDate: z.string().optional(),
	minModelYear: z.string().optional(),
	modelGenerations: z.array(z.string()).optional(),
	modelSeries: z.string().optional(),
	onlineOrderableStatus: z.array(z.string()).optional(),
	previousOwners: z.string().optional(),
	salesStatus: z.array(salesStatusSchema).optional(),
	search: z.string().optional(),
	stockStatus: z.array(stockStatusFilterSchema).optional(),
	transmissions: z.array(z.string()).optional(),
	vatDeductible: z.preprocess(preprocessBoolean, z.boolean()).optional(),
	vehicleTypes: z.array(vehicleTypeFilterSchema).optional(),
})

export type InventoryListFilterValue = z.infer<typeof inventoryListFilterValueSchema>
export type ListingQuality = z.infer<typeof listingQualitySchema>
export type ListingVisibility = z.infer<typeof listingVisibilitySchema>
export type EnginePowerUnit = z.infer<typeof enginePowerUnitSchema>
